<template>
  <div id="wxLogin">
    <div class="wx-info">
      <img :src="userInfo.headimgurl" alt="">
      <p>{{userInfo.nickname}}</p>
      <span>登录成功</span>
    </div>
  </div>

</template>

<script>
export default {
  name: "wxLogin",
  data(){
    return {
      userInfo:{}
    }
  },
  mounted() {
    this.getClientInfo()
  },
  methods: {
    getClientInfo() {
      let urlCode = window.getRequest()
      if (urlCode.hasOwnProperty('code')) {
        window.requestGet('/pc/callback', {
          code: urlCode.code,
          shopid: JSON.parse(localStorage.getItem("userInfo")).shopid,
          userid: JSON.parse(localStorage.getItem("userInfo")).id,
        }, this.$message).then((res) => {
          this.userInfo = res.data
          window.localStorage.setItem("openid", res.data.openid);
        }).catch((error) => {
        })
      }
    },
  }
}
</script>

<style scoped>
body{
  width: 300px;
  height: 300px;
  background: #fff;
}
#wxLogin{
  width: 300px;
  height: 300px;
  background: #fff;
}
.wx-info{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.wx-info img{
  width: 180px;
  height: 180px;
  border-radius: 100%;
}
.wx-info p{
  margin-top: 20px;
  height: 38px;
  font-size: 39px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #222222;
}
.wx-info span{
  display: block;
  margin-top: 100px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #AFAFAF;
}
</style>



// WEBPACK FOOTER //
// src/views/wxLogin.vue